import { useContext } from "react";
import { AppContext } from "../App";
import logo from '../assets/logo.png';
import { MdClose } from "react-icons/md";
import { STRINGS } from "../Strings";

export default function SideBar(props) {
  const appContext = useContext(AppContext);
  const language = appContext.language || "sw";
  const s = STRINGS.topBar.menu; // Tunaita menu moja kwa moja kutoka kwenye topBar strings

  function goTo(item) {
    appContext.navTo({ item });

    if (appContext.isSideBarOpen) {
      appContext.closeSideBar();
    }
  }

  return (
    <div
      className="SideBar mShadow2"
      data-open={appContext.isSideBarOpen}
    >
      <div className="body mNoScrollBar">

        <h6 
          className="text-end"
          onClick={appContext.closeSideBar}
        >
          <MdClose 
            size={32}
            style={{ cursor: "pointer" }}
          />
        </h6>

        <div className="logo-holder">
          <img src={logo} alt="Organization Logo" />
        </div>

        {/* Home Overview */}
        <div
          className="pill"
          onClick={() => goTo("home")}
          data-active={(!appContext.navItem || appContext.navItem === 'home')}
        >
          <p className="text">{s.home[language]}</p>
        </div>

        {/* About Us */}
        <div
          className="pill"
          onClick={() => goTo("about_us")}
          data-active={(appContext.navItem === 'about_us')}
        >
          <p className="text">{s.about[language]}</p>
        </div>

        {/* Services */}
        <div
          className="pill"
          onClick={() => goTo("services")}
          data-active={(appContext.navItem === 'services')}
        >
          <p className="text">{s.services[language]}</p>
        </div>

        {/* Membership / Join Network */}
        <div
          className="pill"
          onClick={() => goTo("membership")}
          data-active={(appContext.navItem === 'membership')}
        >
          <p className="text">{s.membership[language]}</p>
        </div>

        

        {/* Contact Us */}
        <div
          className="pill"
          onClick={() => goTo("contact")}
          data-active={(appContext.navItem === 'contact')}
        >
          <p className="text">{s.contact[language]}</p>
        </div>

      </div>
    </div>
  );
}